import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  ServiceType,
  IndexWrapper,
  // StakingChart,
  StakingContracts,
  // StakingReport,
  StakingRules,
  StakingSection,
} from "@framework/shared";

export const stakingRoutes: Array<RouteObject> = [
  {
    path: "/staking",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="staking">
            <StakingSection />
          </IndexWrapper>
        ),
      },
      {
        path: "/staking/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <StakingContracts service={ServiceType.ADMIN} /> },
          { path: "/staking/contracts/:id/:action", element: <StakingContracts service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/staking/rules",
        element: <Protected />,
        children: [
          { index: true, element: <StakingRules service={ServiceType.ADMIN} /> },

          { path: "/staking/rules/:id/:action", element: <StakingRules service={ServiceType.ADMIN} /> },
        ],
      },
      // {
      //   path: "/staking/report",
      //   element: <Protected />,
      //   children: [
      //     { index: true, element: <StakingReport service={ServiceType.ADMIN} /> },
      //     { path: "/staking/report", element: <StakingReport service={ServiceType.ADMIN} /> },
      //   ],
      // },
      // {
      //   path: "/staking/chart",
      //   element: <Protected />,
      //   children: [
      //     { index: true, element: <StakingChart service={ServiceType.ADMIN} /> },
      //     { path: "/staking/chart", element: <StakingChart service={ServiceType.ADMIN} /> },
      //   ],
      // },
    ],
  },
];
